import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Accordion,
  Card,
  Button,
  Tab,
  Tabs,
  Collapse,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState("0");
  const [open, setOpen] = useState(true);
  const [, setRowInView] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const useObserveInView = (index) => {
    const rowRef = useRef(null);
    const [isInView, setIsInView] = useState(false);
    const [isScrollingDown, setIsScrollingDown] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
      const rowElement = rowRef.current;

      const handleScroll = () => {
        const currentScrollY = window.scrollY;
        setIsScrollingDown(currentScrollY > lastScrollY);
        setLastScrollY(currentScrollY);
      };

      window.addEventListener("scroll", handleScroll);

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && isScrollingDown) {
            setIsInView(true);
          } else {
            setIsInView(false);
          }
        },
        { threshold: 0.5 }
      );

      if (rowElement) {
        observer.observe(rowElement);
      }

      return () => {
        window.removeEventListener("scroll", handleScroll);
        if (rowElement) {
          observer.unobserve(rowElement);
        }
      };
    }, [lastScrollY, isScrollingDown]);

    useEffect(() => {
      setRowInView((prev) => {
        const updated = [...prev];
        updated[index] = isInView;
        return updated;
      });
    }, [isInView, index]);

    return { rowRef, isInView };
  };

  const row1 = useObserveInView(0);
  const row2 = useObserveInView(1);
  const row3 = useObserveInView(2);
  const row4 = useObserveInView(3);
  const row5 = useObserveInView(4);

  return (
    <section className="py-5 about-us" id="aboutus">
      <Container>
        <Row className="text-center mb-lg-5 mb-4" ref={row1.rowRef}>
          <Col>
            <h2
              className={`text-center mb-2 feature-title animate__animated ${
                row1.isInView ? "animate__fadeIn" : ""
              }`}
            >
              {t("aboutUs.title")}
            </h2>
            <p
              className={`hero-description text-dark animate__animated ${
                row1.isInView ? "animate__fadeIn" : ""
              }`}
            >
              {t("aboutUs.description")}
            </p>
          </Col>
        </Row>

        <Row ref={row2.rowRef}>
          <Col className="mb-lg-5 mb-4">
            <Tabs
              activeKey={activeKey}
              onSelect={(k) => setActiveKey(k)}
              className="mb-3 about-tabs"
            >
              <Tab eventKey="0" title={t("aboutUs.tabs.creators")}>
                <Accordion defaultActiveKey="0">
                  <Accordion.Item
                    eventKey="0"
                    className={`animate__animated ${
                      row2.isInView ? "animate__zoomIn" : ""
                    }`}
                  >
                    <Accordion.Header className="accordion-header-about">
                      {t("aboutUs.creatorsTitle")}
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="aboutUs-Description">
                        {t("aboutUs.creatorsDescription")}
                      </p>
                      <p className="aboutUs-Description mb-3">
                        {t("aboutUs.creatorsDescription2")}
                      </p>
                      <strong className="about_strongtxt">
                        {t("aboutUs.teamLabel")}:
                      </strong>
                      <ul>
                        <li className="about_listtxt1">
                          {t("aboutUs.team.aboutTeamName1")}
                        </li>
                        <li className="about_listtxt1">
                          {t("aboutUs.team.aboutTeamName2")}
                        </li>
                        <li className="about_listtxt1">
                          {t("aboutUs.team.aboutTeamName3")}
                        </li>
                        <li className="about_listtxt1">
                          {t("aboutUs.team.aboutTeamName4")}
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Tab>

              <Tab eventKey="1" title={t("aboutUs.tabs.mission")}>
                <Accordion defaultActiveKey="0">
                  <Accordion.Item
                    eventKey="0"
                    className={`animate__animated ${
                      row2.isInView ? "animate__zoomIn" : ""
                    }`}
                  >
                    <Accordion.Header className="accordion-header-about">
                      {t("aboutUs.missionTitle")}
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="aboutUs-Description">
                        {t("aboutUs.missionDescription")}
                      </p>
                      <p className="aboutUs-Description mb-3">
                        {t("aboutUs.missionDescription2")}
                      </p>
                      <strong className="about_strongtxt">
                        {t("aboutUs.missionKeyAspects")}:
                      </strong>
                      <ul>
                        <li className="about_listtxt1">
                          {t("aboutUs.mission.aspect1")}
                        </li>
                        <li className="about_listtxt1">
                          {t("aboutUs.mission.aspect2")}
                        </li>
                        <li className="about_listtxt1">
                          {t("aboutUs.mission.aspect3")}
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Tab>

              <Tab eventKey="2" title={t("aboutUs.tabs.vision")}>
                <Accordion defaultActiveKey="0">
                  <Accordion.Item
                    eventKey="0"
                    className={`animate__animated ${
                      row2.isInView ? "animate__zoomIn" : ""
                    }`}
                  >
                    <Accordion.Header className="accordion-header-about">
                      {t("aboutUs.visionTitle")}
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="aboutUs-Description">
                        {t("aboutUs.visionDescription")}
                      </p>
                      <p className="aboutUs-Description mb-3">
                        {t("aboutUs.visionDescription2")}
                      </p>
                      <strong className="about_strongtxt">
                        {t("aboutUs.visionLongTerm")}:
                      </strong>
                      <ul>
                        <li className="about_listtxt1">
                          {t("aboutUs.vision.item1")}
                        </li>
                        <li className="about_listtxt1">
                          {t("aboutUs.vision.item2")}
                        </li>
                        <li className="about_listtxt1">
                          {t("aboutUs.vision.item3")}
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Tab>
            </Tabs>
          </Col>
        </Row>

        <Row ref={row3.rowRef}>
          <Col className="mb-lg-5 mb-4">
            <h3
              className={`headingText2 mb-lg-3 mb-2 animate__animated ${
                row3.isInView ? "animate__zoomIn" : ""
              }`}
            >
              {t("aboutUs.spiritualTitle")}
            </h3>
            <Accordion defaultActiveKey="0">
              <Accordion.Item
                eventKey="0"
                className={`animate__animated ${
                  row3.isInView ? "animate__zoomIn" : ""
                }`}
              >
                <Accordion.Header className="accordion-header-about">
                  {t("aboutUs.malaChantingTitle")}
                </Accordion.Header>
                <Accordion.Body>
                  <p className="aboutUs-Description">
                    <strong>{t("aboutUs.nityaMala")}</strong>
                    {t("aboutUs.pathToPeace")}
                    <br />
                    {t("aboutUs.malaChantingDescription")}
                    <br />
                    {t("aboutUs.stayConsistent")}
                    <br />
                    {t("aboutUs.dailyPractice")}
                    <br />
                    {t("aboutUs.regularChanting")}
                    <br />
                    {t("aboutUs.spiritualPath")}
                    <br />
                    <br />
                    <strong>{t("aboutUs.importanceOfChanting")} -</strong>
                    <br />
                    {t("aboutUs.malaChantingDetails")}
                    <br />
                    {t("aboutUs.malaChantingDetails2")}
                    <br />
                    {t("aboutUs.malaChantingDetails3")}
                  </p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>

        <Row ref={row4.rowRef}>
          <Col md={6} className="mb-4">
            <Card
              className={`about-infocard border-0 h-100 animate__animated ${
                row4.isInView ? "animate__zoomIn" : ""
              }`}
            >
              <Card.Body>
                <Card.Title>{t("aboutUs.howToPerform")}</Card.Title>
                <Card.Text>
                  <ol>
                    <li className="about_listtxt1">
                      {t("aboutUs.practiceStep1")}
                    </li>
                    <li className="about_listtxt1">
                      {t("aboutUs.practiceStep2")}
                    </li>
                    <li className="about_listtxt1">
                      {t("aboutUs.practiceStep3")}
                    </li>
                    <li className="about_listtxt1">
                      {t("aboutUs.practiceStep4")}
                    </li>
                  </ol>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="mb-4">
            <Card
              className={`about-infocard border-0 h-100 animate__animated ${
                row4.isInView ? "animate__zoomIn" : ""
              }`}
            >
              <Card.Body>
                <Card.Title>{t("aboutUs.why108Beads")}</Card.Title>
                <Card.Text>
                  <p className="aboutUs-Description">
                    {t("aboutUs.why108Description")}
                  </p>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="mb-4">
            <Card
              className={`about-infocard border-0 h-100 animate__animated ${
                row4.isInView ? "animate__zoomIn" : ""
              }`}
            >
              <Card.Body>
                <Card.Title>{t("aboutUs.typesOfMalas")}</Card.Title>
                <Card.Text>
                  <ol>
                    <li className="about_listtxt1">{t("aboutUs.mala1")}</li>
                    <li className="about_listtxt1">{t("aboutUs.mala2")}</li>
                    <li className="about_listtxt1">{t("aboutUs.mala3")}</li>
                    <li className="about_listtxt1">{t("aboutUs.mala4")}</li>
                  </ol>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="mb-4">
            <Card
              className={`about-infocard border-0 h-100 animate__animated ${
                row4.isInView ? "animate__zoomIn" : ""
              }`}
            >
              <Card.Body>
                <Card.Title>{t("aboutUs.benefitsTitle")}</Card.Title>
                <Card.Text>
                  <ul>
                    <li className="about_listtxt1">{t("aboutUs.benefit1")}</li>
                    <li className="about_listtxt1">{t("aboutUs.benefit2")}</li>
                    <li className="about_listtxt1">{t("aboutUs.benefit3")}</li>
                    <li className="about_listtxt1">{t("aboutUs.benefit4")}</li>
                    <li className="about_listtxt1">{t("aboutUs.benefit5")}</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row ref={row5.rowRef}>
          <Col>
            <Button
              onClick={() => setOpen(!open)}
              aria-controls="collapse-text"
              aria-expanded={open}
              className={`learn-more-btn border-0 text-light animate__animated ${
                row5.isInView && open ? "animate__zoomIn" : ""
              }`}
            >
              {t("aboutUs.learnMoreBtn")}
            </Button>

            <Collapse in={open}>
              <div
                id="collapse-text"
                className={`mt-3 p-4 collapse-content rounded-3 animate__animated ${
                  open && row5.isInView ? "animate__zoomIn" : ""
                }`}
              >
                <p className="aboutUs-Description">
                  <p className="mb-lg-3 mb-2">{t("aboutUs.learnMoreText1")}</p>
                  <p className="mb-lg-3 mb-2">{t("aboutUs.learnMoreText2")}</p>
                  <p className="mb-lg-3 mb-2">
                    {t("aboutUs.nityaMalaPowerful")}
                  </p>
                  <p className="mb-lg-3 mb-2">
                    {t("aboutUs.nityaMalaPowerful2")}
                  </p>
                  <p className="mb-lg-3 mb-2"> {t("aboutUs.startToday")}</p>
                  <p className="mb-lg-3 mb-2"> {t("aboutUs.startToday2")}</p>
                  <p className="mb-lg-3 mb-2">
                    {t("aboutUs.strengthenSpiritualPath")}
                  </p>
                </p>
              </div>
            </Collapse>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutUs;
